<template>
  <select :value="value" @input="$emit('input', $event.target.value)" class="form-select">
    <template v-for="hr in hours">
      <template v-for="min in minutes">
        <option :value="`${hr}:${min}:00`" :key="`${hr}:${min}`">
          {{ hr }}:{{ min }}
        </option>
      </template>
    </template>
  </select>
</template>

<script>
export default {
  name: 'TimePicker',

  props: {
    minuteIncrement: {
      type: Number,
      default: 10
    },

    value: {
      type: String
    }
  },

  computed: {
    hours () {
      let array = []
      for (let i = 0; i < 24; i++) {
        let hr = i < 10 ? '0' + i : i
        array.push(hr)
      }
      return array
    },

    minutes () {
      let array = []
      for (let i = 0; i < 60; i = i + this.minuteIncrement) {
        let min = i < 10 ? '0' + i : i
        array.push(min)
      }
      return array
    }
  }
}
</script>

